// @flow
import {connect} from 'react-redux';
import MyStore from '../components/MyStore';

import type {RootState} from '../../../modules';

export default connect(
  (state: RootState) => ({
    user: state.auth.user,
    store: state.store.store,
    storeInformation: state.ui.storeInformation,
  }),
  null
)(MyStore);
